module.exports = __webpack_public_path__ + "static/media/var.0943d60a.jpg";